import { Container, Button } from "../components";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { GENERAL_ICONS, generalIcons, redirections, SOCIAL_LINKS } from "../utils/constants";
import { addChain } from "../utils/helper";

function Footer() {

    const [showHoverIcon, setShowHoverIcon] = useState(false)

    return (
        <footer className="relative pt-[50px] lg:pt-[100px]">
            <Container>
                <div className="relative py-[50px] lg:py-20 w-full before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-footerBorderLine before:bg-contain before:bg-top before:bg-no-repeat z-10">
                    <div className="grid xl:grid-cols-4 gap-x-4 gap-y-10 relative z-10">
                        <div className="col-span-1">
                            <div className="text-center xl:text-left xl:pr-[5vw]">
                                <div className="w-3/4 mb-5 mx-auto xl:mx-0 *:w-full">
                                    {GENERAL_ICONS.footer_logo}
                                </div>
                                <p className="mb-5 laptop:mb-8 text-xsm lg:text-sm">
                                    The flat fee, lightning fast chain, made for mainstream mass
                                    adoption.
                                </p>

                                <Button id="addVanarToMetamask" onMouseEnter={()=>setShowHoverIcon(true)} onMouseLeave={()=>setShowHoverIcon(false)} onClick={addChain} className="outline-btn py-[10px] px-[25px] !text-sm">
                                    <span className="mr-[10px]">
                                        {showHoverIcon ? generalIcons.walletHover :generalIcons.wallet}
                                    </span>
                                    Add Vanar to Your Wallet
                                </Button>
                            </div>
                        </div>
                        <div className="xl:col-span-3">
                            <div className="grid lg:grid-cols-4 xl:grid-cols-5 gap-8">
                                <div className="col-span-1 lg:justify-items-center xl:justify-items-end">
                                    <div className="relative">
                                        <strong className="mb-5 lg:mb-8 text-[24px]/6 inline-block">
                                            Links
                                        </strong>
                                        <ul className="flex flex-wrap lg:flex-col items-center lg:items-start gap-y-3 gap-x-6 lg:gap-5 mobHashEffect">
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.PARTNERS}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Ecosystem
                                                </a>
                                            </li>
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.VALIDATORS}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Validators
                                                </a>
                                            </li>
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.DEVELOPERS}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Developers
                                                </a>
                                            </li>
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.ACADEMY}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Vanar Academy
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-span-1 lg:justify-items-center xl:justify-items-end">
                                    <div className="relative">
                                        <strong className="mb-5 lg:mb-8 text-[24px]/6 inline-block">
                                            About
                                        </strong>
                                        <ul className="flex flex-wrap lg:flex-col items-center lg:items-start gap-y-3 gap-x-6 lg:gap-5 mobHashEffect">
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.VANRY}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    $VANRY Token
                                                </a>
                                            </li>
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.NEWS}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    News
                                                </a>
                                            </li>
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.BLOG}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Blog
                                                </a>
                                            </li>
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.BRANDGUIDELINES}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Brand Guidelines
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-span-1 lg:justify-items-center xl:justify-items-end">
                                    <div className="relative">
                                        <strong className="mb-5 lg:mb-8 text-[24px]/6 inline-block">
                                            Solutions
                                        </strong>
                                        <ul className="flex flex-wrap lg:flex-col items-center lg:items-start gap-y-3 gap-x-6 lg:gap-5 mobHashEffect">
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.EXPLORER}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Explorer
                                                </a>
                                            </li>
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.DOCS}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Documentation
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-span-1 lg:justify-items-center xl:justify-items-end">
                                    <div className="relative">
                                        <strong className="mb-5 lg:mb-8 text-[24px]/6 inline-block">
                                            Use Cases
                                        </strong>
                                        <ul className="flex flex-wrap lg:flex-col items-center lg:items-start gap-y-3 gap-x-6 lg:gap-5 mobHashEffect">
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.ECO}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Vanar ECO
                                                </a>
                                            </li>
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.GAMING}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Vanar Gaming
                                                </a>
                                            </li>
                                            <li className="relative">
                                                <a
                                                    className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                                                    href={redirections.AI}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Vanar AI
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-span-1 lg:justify-items-center xl:justify-items-end hidden xl:block">
                                    <div className="relative">
                                        <strong className="mb-5 lg:mb-8 text-[24px]/6 inline-block">
                                            Follow Us
                                        </strong>
                                        <ul className="flex flex-wrap lg:flex-col items-center lg:items-start gap-y-3 gap-x-6 lg:gap-5 mobHashEffect">
                                            {SOCIAL_LINKS.map((item) => (
                                                <li key={item.name}>
                                                    <a
                                                    id={item.id}
                                                        className="flex items-center gap-2 text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green capitalize"
                                                        href={item.url}
                                                    >
                                                        <span className="w-[15px] h-[15px] flex items-center justify-center *:w-full *:h-full">
                                                            {item.svg}
                                                        </span>
                                                        {item.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="relative py-5 lg:py-10 w-full flex flex-col lg:flex-row justify-between items-center gap-5 before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-footerBorderLine before:bg-contain before:bg-top before:bg-no-repeat">
                    <div className="flex flex-col xl:flex-row items-center lg:items-start justify-between gap-5 w-full order-2 lg:order-1 z-[1]">
                        <p className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70">
                            Copyright © {new Date().getFullYear()} Vanar Chain
                        </p>

                        <div className="flex items-center gap-4 text-sm/4 text-dim/70">
                            <a
                                href="https://docs.vanarchain.com/nodes-and-validators/staking"
                                target="_blank"
                                rel="norefferer"
                                className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                            >
                                Guide
                            </a>
                            <Link
                                to="/terms"
                                className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                            >
                                Terms & Conditions
                            </Link>
                            <Link
                                to="/privacy-policy"
                                className="text-xsm/4 lg:text-sm/4 font-medium text-dim/70 duration-300 -tracking-03 hover:text-green"
                            >
                                Privacy Policy
                            </Link>
                        </div>
                    </div>

                    <ul className="flex items-center gap-[15px] xl:hidden order-1">
                        {SOCIAL_LINKS.map((item) => (
                            <li key={item.name}>
                                <a
                                    className="w-10 h-10 p-1 bg-lightGray/15 rounded-full flex items-center justify-center text-dim/70 duration-300 hover:bg-white/20"
                                    href={item.url}
                                >
                                    {item.svg}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;
